export const LOCALE_PREFIX = 'components.FinanceAnalysis'

export const FANAL_TOGGLE_GRAPH_TABLE = 'FANAL_TOGGLE_GRAPH_TABLE'
export const FANAL_CHANGE_SELECTED_YEAR = 'FANAL_CHANGE_SELECTED_YEAR'
